import { WSysLayout } from '@coimbra-its/websys-ux-core';
import { AppHub, WebSysNav } from './sys/NavBar';

import { Box, Button, Img } from '@chakra-ui/react';
import { useWSysAuthSlice } from './store/authSlice';
import SignInForm from './sys/SignInForm';
import { SignOut } from './sys/SignOut';
import { WSysServerMessages } from './temp/serverMessage';
import { useNavigate, NavigateFunction } from 'react-router-dom';
import { MdRefresh } from 'react-icons/md';

console.log('STARTED WITH API:', process.env.REACT_APP_API_BASE_URL);
const GLOBAL_NAVIGATE : { nav?: NavigateFunction  } = { };

function App() {
	const authSlice = useWSysAuthSlice();
	const user = authSlice.user;
	GLOBAL_NAVIGATE.nav = useNavigate();



	return (<>
		{!user
			? <WSysLayout>
				<SignInForm />
			</WSysLayout>
			: <WSysLayout nav={<WebSysNav isWide={false} />}>
				<AppHub />
				<SignOut />
			</WSysLayout>
		}
		<WSysServerMessages />
		{authSlice.updateAvailable &&
			<Button
				position="fixed"
				bottom={4}
				right={4}
				zIndex="9999"
				colorScheme="yellow"
				leftIcon={<MdRefresh />}
				boxShadow="lg"
				onClick={() => window.location.reload()}
			>
				Frissítés elérhető
			</Button>
		}
	</>);
}

export default App;

// ================================================= RECEIVE MESSAGE FROM SERVICE WORKER ========================================
// ezt viszont magam hívom serviceWorker-ből, ha olyan üzenet jött és rákattintottak
if (navigator.serviceWorker) {
	navigator.serviceWorker.addEventListener("message", (event) => {
		console.log('MESSAGE RECEIVED FROM SERVICE WORKER: ', event.data);
		if (event.data && event.data.msg === "push-notification-received" && event.data.path && GLOBAL_NAVIGATE.nav) {
				GLOBAL_NAVIGATE.nav(event.data.path);
		}
	});
}